/* src/app/warehousing/partials/assistant-launcher/assistant-launcher.component.scss */
.assistantFab {
  position: fixed;
  right: 1.5rem;
  bottom: 1.5rem;
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 50%;
  border: none;
  background:
    linear-gradient(
      135deg,
      #f99420,
      #e07f0e);
  color: #fff;
  font-size: 1.4rem;
  box-shadow: 0 4px 14px rgba(249, 148, 32, 0.4);
  cursor: pointer;
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}
.assistantFab:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 18px rgba(249, 148, 32, 0.5);
}
.assistantPopover {
  position: fixed;
  right: 1.5rem;
  bottom: 5.5rem;
  width: 26rem;
  max-width: calc(100vw - 3rem);
  max-height: calc(100vh - 8rem);
  background: #fff;
  border-radius: 0.75rem;
  box-shadow: 0 10px 40px rgba(15, 23, 42, 0.25);
  display: flex;
  flex-direction: column;
  z-index: 1049;
  overflow: hidden;
}
.assistantPopoverHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 0 0 auto;
  padding: 0.9rem 1.1rem;
  background: #1a1a1a;
  color: #fff;
  font-weight: 600;
  font-size: 0.95rem;
}
.assistantPopoverHeader .closeBtn {
  background: transparent;
  border: none;
  color: #fff;
  opacity: 0.75;
  cursor: pointer;
  font-size: 0.95rem;
}
.assistantPopoverHeader .closeBtn:hover {
  opacity: 1;
}
.assistantPopoverBody {
  padding: 1rem 1.1rem;
  overflow-y: auto;
  flex: 1 1 auto;
}
/*# sourceMappingURL=assistant-launcher.component.css.map */
